import { Stack, Text, Card, ContentBlock } from 'braid-design-system';
import React, { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { dispatchResetNotificationSettings } from 'src/app/state/dispatcher/notificationsSetting';
import { useQueryParams } from 'src/app/views/hooks/useQueryParams';
import type AppState from 'src/types/appState';

import { SuccessBody } from '../Success/components/SuccessBody';

const TextMessage = ({ text }: { text: string }) => (
  <ContentBlock>
    <Card>
      <Text align="center">{text}</Text>
    </Card>
  </ContentBlock>
);

export const TestPage = () => {
  const auTestAccountId = '1';
  const nzTestAccountId = '2';

  const { advertiserId, isInNotificationsSettingMode } = useSelector(
    (state: AppState) => ({
      advertiserId: state.session.advertiserId,
      isInNotificationsSettingMode:
        state.session.notificationsSetting.isInSettingMode,
    }),
    shallowEqual,
  );

  const dispatch = useDispatch();

  const { getJobIdParam } = useQueryParams();
  const jobIdParam = getJobIdParam();

  useEffect(() => {
    if (jobIdParam) {
      dispatch(dispatchResetNotificationSettings());
    }
  }, [dispatch, jobIdParam]);

  if (advertiserId !== auTestAccountId && advertiserId !== nzTestAccountId) {
    return <TextMessage text="This test page is only for test accounts" />;
  }

  return (
    <Stack space="large">
      {isInNotificationsSettingMode ? null : (
        <TextMessage text="A testing page for incoming features" />
      )}
      <SuccessBody
        jobId={jobIdParam!}
        inNotificationSettings={isInNotificationsSettingMode}
      />
    </Stack>
  );
};

export default TestPage;
